const API_URL = process.env.REACT_APP_API_URL + "/api";

export const postCreateProject = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/create-project`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const postCrewMatch = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/match-crew`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const postAssignMatch = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/assignMatchCrew`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const getActiveProjects = async () => {
  const apiUrl = `${API_URL}/admin/get-active-projects`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  console.log("response getActiveProjects", response);
  if (!response.ok) {
    let error = await response.json();
    throw new Error(error.message || 'Failed to fetch active projects');
  }

  return response.json();
}

export const postEquipmentMatch = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/matchEquipments`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const postAssignEquipments = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/assignMatchEquipment`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}


export const postProjectBrief = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/final-project-brief`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}


export const getProject = async (projectId) => {
  const apiUrl = `${API_URL}/admin/get-project/${projectId}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const getEventTypes = async () => {
  const apiUrl = `${API_URL}/admin/get-event-types`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  console.log("response getEventTypes", response);
  if (!response.ok) {
    let error = await response.json();
    throw new Error(error.message || 'Failed to fetch events');
  }

  return response.json();
}
